export const BACKEND_APIS = {
	CRUD: '/api/crud',
	USER: '/api/user',
	REPORTS: '/api/reports',
	EXECUTION_INFO: '/api/execution_info',
	EXECUTION_INFO_EXTRA: '/api/reports-extras/execution-info',
	EUROPCAR_ANALYTICS: '/api/search_analytics/europcar',
	HISTORICAL: '/api/historic',
	INTERMEDIARY: '/api/intermediary',
	MASTER_DATA: '/api/master-data',
	SEARCH: '/search',
	SESSION: '/api/session',
	REPORT: '/api/reports',
	REPORT_EXTRA: '/api/reports-extras',
	BATCH: '/api/batch',
	DASHBOARD: '/api/dashboard',
	CONDITIONS: '/api/alerts/conditions',
	NOTIFICATIONS: '/api/alerts/notifications',
	SEARCH_ANALYTICS: '/api/search_analytics/searches',
	SEARCH_ANALYTICS_EXCEL: '/api/search_analytics/excel',
	CUSTOM_CATEGORY: '/api/custom-categories',
	CUSTOM_ACRISS: '/api/custom-acriss',
	OFFICE_MAPPING: '/api/office-mapping',
	REPORTS_DOWNLOAD_RATING: '/api/reports/download/rating',
	REPORTS_MULTI_DOWNLOAD_RATING: '/api/reports/multi/download/rating',
	REPORTS_EXECUTIONS_RATING: '/api/reports/executions/rating',
	ADMIN: '/api/admin',
	// News: the popup and the News button (feed) and News Management (`/admin`)
	ANNOUNCEMENTS: '/api/announcements',
    MIGRATION: '/api/migration',
	AUTOEUROPE_PRICING_TOOL: '/api/pricing-tool/autoeurope',
	DS_REPRICING: '/api/pricing-tool/ds',
	// General (PMS) repricing Setup — webback blueprint `repricing` (CU-869f043ba).
	// Not to be confused with DS_REPRICING above, which is the AutoEurope system.
	GENERAL_REPRICING_SETUP_API: '/api/repricing/setup',
	// The activity log is not Setup: it is what the engine did, not
	// what it was told to do, and its routes hang off the blueprint
	// root. Pointing the feed at the Setup base asked for
	// `/setup/activity` and got a 404 the screen rendered as an
	// empty log (2026-09-27).
	GENERAL_REPRICING_ACTIVITY_API: '/api/repricing',
	// Executions and the migration state (CU-869fhuhy6): `/executions*`, `/migration`.
	GENERAL_REPRICING_API: '/api/repricing',
	GENERAL_REPRICING_STRATEGIES_API: '/api/repricing/strategies',
	GENERAL_REPRICING_SCHEDULE_API: '/api/repricing/schedule',
}

const __ANALYZERS_PATH = '/analyzers'
export const ANALYZERS_ROUTES = {
	PATH: __ANALYZERS_PATH,
	TITLE: 'Analyzers',
	SUBTITLE: '',

	LOR_PATH: `${__ANALYZERS_PATH}/lor`,
	LOR_SUBTITLE: 'LOR Analyzer',

	DOR_PATH: `${__ANALYZERS_PATH}/dor`,
	DOR_SUBTITLE: 'DOR Analyzer',

	DIRECT_SITE_PATH: `${__ANALYZERS_PATH}/direct-site`,
	DIRECT_SITE_SUBTITLE: 'Direct Site Analyzer',

	BROKERS_PATH: `${__ANALYZERS_PATH}/brokers`,
	BROKERS_SUBTITLE: 'Brokers Analyzer',

	RATING_PATH: `${__ANALYZERS_PATH}/rating`,
	RATING_SUBTITLE: 'Rating Analyzer',

	POSITION_PATH: `${__ANALYZERS_PATH}/position`,
	POSITION_SUBTITLE: 'Rank Analyzer',
}

const __ONE_WAY_PATH = '/one-way'
export const ONE_WAY_ROUTES = {
	PATH: __ONE_WAY_PATH,
	TITLE: 'One Way',
	SUBTITLE: '',

	REPORTS_PATH: `${__ONE_WAY_PATH}/reports`,
	REPORTS_TITLE: 'One Way Reports',

	ANALYZER_PATH: `${__ONE_WAY_PATH}/analyzer`,
	ANALYZER_TITLE: 'One Way Analyzer',

	// kept only to redirect to User Settings › Acriss groups, where the page moved (CU-869fkp1t3)
	ACRISS_GROUPS_PATH: `${__ONE_WAY_PATH}/acriss-groups`,

	GROUPS_PATH: `${__ONE_WAY_PATH}/groups`,
	GROUPS_TITLE: 'Grouped Reports',

	// kept only to redirect the URLs used before the One Way menu split
	LEGACY_REPORTS_PATH: '/reports/one-ways',
	LEGACY_ANALYZER_PATH: '/analyzers/one-way',
}

export const REAL_TIME_ROUTES = {
	PATH: '/real-time',
	TITLE: 'Real time',
	// Top-level menu sections are Title Case; the page title stays "Real time" (Curro, CU-869fmjzrg)
	MENU_TITLE: 'Real Time',
	SUBTITLE: 'Searches',
	SEARCHES_PATH: '/real-time/searches',
	HISTORY_PATH: '/real-time/history',
	HISTORY_TITLE: 'Historical',
	HISTORY_SUBTITLE: 'Performed Searches',
}

// The old module's address: only the alias that redirects to `ADMIN_ROUTES.NEWS_MANAGEMENT_PATH` (CU-869fmherf)
export const NEWS_MANAGEMENT_ROUTES = {
	PATH: '/news-management',
	TITLE: 'News Management',
	SUBTITLE: 'Publish in-app announcements and choose who sees them',
}

export const BATCH_ROUTES = {
	PATH: '/batch-list',
	TITLE: 'Batches',
	SUBTITLE: 'Executed processes',
}

const __REPORT_PATH = '/reports'
export const REPORT_ROUTES = {
	PATH: __REPORT_PATH,
	TITLE: 'Reports',
	SUBTITLE: 'List',
	MAIN_TITLE: 'Reports List',

	COMMON_PATH: `${__REPORT_PATH}/list`,
	COMMON_SUBTITLE: 'List',

	EXTRA_PATH: `${__REPORT_PATH}/extra`,
	LIST_PATH: `${__REPORT_PATH}/list`,
	EXTRA_TITLE: 'Extras & Protections',
	EXTRA_SUBTITLE: 'Extras & Protections',

	RATING_PATH: `${__REPORT_PATH}/rating`,
	RATING_TITLE: 'Rating Reports',
	RATING_SUBTITLE: 'Rating',

	GROUPING_PATH: `${__REPORT_PATH}/groups`,
	GROUPING_TITLE: 'Grouped Exports',

	CONDITIONS_PATH: `${__REPORT_PATH}/conditions`,
	CONDITIONS_TITLE: 'Alert Conditions',
	NOTIFICATION_PATH: `${__REPORT_PATH}/notifications`,
	NOTIFICATION_TITLE: 'Alert Notifications',
}

const __USER_PATH = '/user'
export const USER_ROUTES = {
	PATH: __USER_PATH,
	TITLE: 'User Settings',
	SUBTITLE: '',

	SETTINGS_PATH: `${__USER_PATH}/settings`,
	SETTINGS_SUBTITLE: 'Manage Settings',
	CUSTOM_MAPPING_PATH: `${__USER_PATH}/custom-mapping`,
	CUSTOM_MAPPING_SUBTITLE: 'Custom Mapping',
	// Iris's profile: its own page since CU-869fmherf (was the Settings tab `?tab=iris`, which redirects here)
	IRIS_PATH: `${__USER_PATH}/iris`,
	IRIS_SUBTITLE: 'Iris',
}

export const SESSIONS_ROUTES = {
	LOGIN_URL: '/login',
	LOGIN_API_URL: '/loginapi',
	LOGIN_TITLE: 'Login',

	LOGOUT_URL: '/logout',
}

export const MY_BUSINESS_ROUTES = {
	PATH: '/my-business',
	TITLE: 'My Business',
	SUBTITLE: 'Operations from your PMS',

	// Revenue (A1) — landing of the module
	REVENUE_PATH: '/my-business/revenue',
	REVENUE_TITLE: 'Revenue',
	REVENUE_SUBTITLE: 'KPIs, monthly evolution and drill-downs',

	// Fleet (A3) — fleet size, utilization, peaks
	FLEET_PATH: '/my-business/fleet',
	FLEET_TITLE: 'Fleet',
	FLEET_SUBTITLE: 'Fleet size, utilization and breakdowns',

	// Forecast (A4) — OTB pipeline and forward-looking projection
	FORECAST_PATH: '/my-business/forecast',
	FORECAST_TITLE: 'Forecast',
	FORECAST_SUBTITLE: 'OTB pipeline and forward-looking projection',

	// Market (B1) — latest competitor prices for the operator's catalog
	MARKET_PATH: '/my-business/market',
	MARKET_TITLE: 'Market',
	MARKET_SUBTITLE: 'Latest competitor prices for your offices and categories',

	// Performance — heatmap matrix Channel × Category × 4 metrics vs PY
	PERFORMANCE_PATH: '/my-business/performance',
	PERFORMANCE_TITLE: 'Performance',
	PERFORMANCE_SUBTITLE: 'Where the business progresses or regresses: Channel × Category × Revenue/Bookings/Days/RPD vs PY',

	// Admin (D1-D9) — single tabbed page
	ADMIN_PATH: '/my-business/admin',
	ADMIN_TITLE: 'Admin',
	ADMIN_SUBTITLE: 'Mappings (PMS ↔ Price Seeker) and tenant configuration',

	// Individual section titles, used by the embedded admins
	CHANNEL_ADMIN_TITLE: 'Channel Mapping',
	CHANNEL_ADMIN_SUBTITLE: 'Map PMS booking channels to canonical types',
	OFFICE_ADMIN_TITLE: 'Office Mapping',
	OFFICE_ADMIN_SUBTITLE: 'Map PMS offices to Price Seeker offices',
	CATEGORY_ADMIN_TITLE: 'Category Mapping',
	CATEGORY_ADMIN_SUBTITLE: 'Map PMS SIPP codes to Price Seeker ACRISS',
	AGENCY_ADMIN_TITLE: 'Agency Mapping',
	AGENCY_ADMIN_SUBTITLE: 'Map PMS agencies/brokers to Price Seeker sites',
	CHECKOUT_ADMIN_TITLE: 'CheckOut Config',
	CHECKOUT_ADMIN_SUBTITLE: 'Short/Long threshold and per-day vs per-checkout prorating',
}


export const BUSINESS_LOGISTICS_ROUTES = {
	PATH: '/business-logistics',
	// Shown as "Business Intelligence" since CU-869fmherf; paths and names keep "business-logistics" so links do not break
	TITLE: 'Business Intelligence',
	SUBTITLE: 'Analytics & Intelligence',

	// BI dashboards (CU-869fmhmx8): first in the menu
	SEASON_VS_LY_PATH: '/business-logistics/season-vs-last-year',
	SEASON_VS_LY_TITLE: 'Season vs last year',
	SEASON_VS_LY_SUBTITLE: 'Market prices vs a past period',
	// CU-869fmjzrg: second in the menu (Curro's decision 8); "Week by week" replaces Pricing Environment
	PRICE_CURVE_PATH: '/business-logistics/price-curve',
	PRICE_CURVE_TITLE: 'Price curve of a date',
	PRICE_CURVE_SUBTITLE: 'Who moved and when',
	// CU-869fmjzrh: where you stand, office by office (replaces Leading Analyzer)
	OFFICE_NETWORK_PATH: '/business-logistics/my-office-network',
	OFFICE_NETWORK_TITLE: 'My office network',
	OFFICE_NETWORK_SUBTITLE: 'Where you stand, office by office',

	// BI Routes: the explorer (pivot table), last in the menu as "Advanced (BI)" since CU-869fmhmx8 (Curro's decision 6);
	// the page title follows. Path unchanged, so links and bookmarks keep opening.
	BI_PATH: '/business-logistics/bi',
	BI_TITLE: 'Advanced (BI)',
	BI_SUBTITLE: 'Business Intelligence',

	// Europcar Routes
	EUROPCAR_PATH: '/business-logistics/europcar',
	EUROPCAR_TITLE: 'Europcar',
	EUROPCAR_MENU_TITLE: 'Europcar Custom Search Analytics',
	EUROPCAR_SUBTITLE: 'Search Analytics',

	// Pricing Environment Routes
	PRICING_ENV_PATH: '/business-logistics/pricing-environment',
	PRICING_ENV_TITLE: 'Pricing Environment',
	PRICING_ENV_SUBTITLE: 'Pricing Environment',

	// Leading Analyzer Routes
	LEADING_ANALYZER_PATH: '/business-logistics/leading-analyzer',
	LEADING_ANALYZER_TITLE: 'Leading Analyzer',
	LEADING_ANALYZER_SUBTITLE: 'Leading Prices',
}

const __AUTO_EUROPE_TOOL_PATH = '/autoeurope-pricing-tool'
export const AUTO_EUROPE_TOOL_ROUTES = {
	PATH: __AUTO_EUROPE_TOOL_PATH,
	TITLE: 'AutoEurope Pricing Tool',
	SUBTITLE: 'AutoEurope',

	CONFIGURATION_PATH: `${__AUTO_EUROPE_TOOL_PATH}/configuration`,
	CONFIGURATION_TITLE: 'Configuration',
	CONFIGURATION_SUBTITLE: 'Pricing Configuration',

	PRICING_ID_PATH: `${__AUTO_EUROPE_TOOL_PATH}/pricing-id`,
	PRICING_ID_TITLE: 'Pricing ID',
	PRICING_ID_SUBTITLE: 'Pricing ID Configuration',

	PROVIDER_NORMALIZATION_PATH: `${__AUTO_EUROPE_TOOL_PATH}/provider-normalization`,
	PROVIDER_NORMALIZATION_TITLE: 'Provider Normalization',
	PROVIDER_NORMALIZATION_SUBTITLE: 'Provider Normalization Configuration',

	NOTIFICATIONS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/notifications`,
	NOTIFICATIONS_TITLE: 'Notifications',
	NOTIFICATIONS_SUBTITLE: 'Pricing Tool Notifications',

	CHECKERS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/checkers`,
	CHECKERS_TITLE: 'Checkers',
	CHECKERS_SUBTITLE: 'Pricing Tool Checkers',

	SEASON_SETS_PATH: `${__AUTO_EUROPE_TOOL_PATH}/season-sets`,
	SEASON_SETS_TITLE: 'Season Sets',
	SEASON_SETS_SUBTITLE: 'Season Sets Configuration',
}

const __DS_REPRICING_PATH = '/ds-repricing'
export const DS_REPRICING_ROUTES = {
	PATH: __DS_REPRICING_PATH,
	TITLE: 'DS Repricing',
	SUBTITLE: 'Automated pricing engine — strategies, setup and activity log',

	STRATEGIES_PATH: `${__DS_REPRICING_PATH}/strategies`,
	STRATEGIES_TITLE: 'Strategies',
	STRATEGIES_SUBTITLE: 'Rules the engine runs against each rate shop',

	SETUP_PATH: `${__DS_REPRICING_PATH}/setup`,
	SETUP_TITLE: 'Setup',
	SETUP_SUBTITLE: 'Repricing general setup',

	// Legacy alias since the 28 re-cut (CU-869fhuhy6): bounces to EXECUTIONS.
	SCHEDULE_PATH: `${__DS_REPRICING_PATH}/schedule`,
	SCHEDULE_TITLE: 'Schedule',
	SCHEDULE_SUBTITLE: 'When the engine runs and which strategies cover each day',
	// The old Schedule window, kept read-only until the migration is validated. Not in the menu.
	SCHEDULE_LEGACY_PATH: `${__DS_REPRICING_PATH}/schedule-legacy`,
	SCHEDULE_LEGACY_TITLE: 'Schedule · legacy (read-only)',

	EXECUTIONS_PATH: `${__DS_REPRICING_PATH}/executions`,
	EXECUTIONS_TITLE: 'Executions',
	EXECUTIONS_SUBTITLE: 'Every pass of the engine, newest first — which strategies asked for it and what it decided',

	ACTIVITY_PATH: `${__DS_REPRICING_PATH}/activity`,
	ACTIVITY_TITLE: 'Activity log',
	ACTIVITY_SUBTITLE: 'Every hit the repricing engine handles',

	// Legacy: bookmarks land here and get bounced to ACTIVITY with
	// the blocked event-type filter pre-applied. Hidden from the menu.
	BLOCKED_PATH: `${__DS_REPRICING_PATH}/blocked`,

	// Backwards-compat alias — old bookmarks land here and get redirected
	// to STRATEGIES_PATH. Do NOT expose in the menu.
	CONFIGURATION_PATH: `${__DS_REPRICING_PATH}/configuration`,
}

export const BI_ROUTES = {
	PATH: BUSINESS_LOGISTICS_ROUTES.BI_PATH,
	TITLE: BUSINESS_LOGISTICS_ROUTES.BI_TITLE,
	SUBTITLE: BUSINESS_LOGISTICS_ROUTES.BI_SUBTITLE,
}

export const EUROPCAR_ROUTES = {
	MAIN_PATH: BUSINESS_LOGISTICS_ROUTES.PATH,
	ANALYTICS_PATH: '/europcar',
	PRICING_ENV_PATH: '/pricing-environment',
	TITLE: BUSINESS_LOGISTICS_ROUTES.EUROPCAR_TITLE,
	PRICING_ENV_SUBTITLE: BUSINESS_LOGISTICS_ROUTES.PRICING_ENV_TITLE,
	ANALYTICS_SUBTITLE: BUSINESS_LOGISTICS_ROUTES.EUROPCAR_TITLE,
}

const __ADMIN_PATH = '/admin'
export const ADMIN_ROUTES = {
	PATH: __ADMIN_PATH,
	GLOBAL_EXECUTION_PATH: `${__ADMIN_PATH}/execution-status`,
	GLOBAL_EXECUTION_SUBTITLE: 'Global Execution Status',
	CUSTOM_OFFICE_PATH: `${__ADMIN_PATH}/office-mapping`,
	CUSTOM_OFFICE_SUBTITLE: 'Custom Offices Mapping',
	USER_CONFIG_PATH: `${__ADMIN_PATH}/users-config`,
	USER_CONFIG_SUBTITLE: 'Users Control Panel',
	EXPORT_CONNECTIONS_SUBTITLE: 'Export Connections',
	EXPORT_CONNECTIONS_PATH: `${__ADMIN_PATH}/export-connections`,
	PROVIDERS_WEB_SUPPLIERS_MAPPING_PATH: `${__ADMIN_PATH}/providers-suppliers-mapping`,
	PROVIDERS_WEB_SUPPLIERS_MAPPING_SUBTITLE: 'Providers & Web Suppliers Mapping',
	GROUPED_EXPORTS_PATH: `${__ADMIN_PATH}/grouped-exports`,
	GROUPED_EXPORTS_SUBTITLE: 'Grouped Exports',
	GROUPED_EXTRA_EXPORTS_PATH: `${__ADMIN_PATH}/grouped-exports-extra`,
	GROUPED_EXTRA_EXPORTS_SUBTITLE: 'Grouped Exports Extra',
	REPORT_HANDLER_SUBTITLE: 'Reports Handler',
	REPORT_HANDLER_PATH: `${__ADMIN_PATH}/reports-handler`,
	// News Management inside Admin since CU-869fmherf (was its own module at `/news-management`, now an alias)
	NEWS_MANAGEMENT_PATH: `${__ADMIN_PATH}/news-management`,
	NEWS_MANAGEMENT_SUBTITLE: 'News Management',
	TITLE: 'Admin',
}

export const HOME_ROUTES = {
	PATH: '/main',
	TITLE: 'Main Page',
	HOME_PATH: '/main/home',
	HOME_TITLE: 'Home',
	SEARCH_ANALYTICS_PATH: '/main/search-analytics',
	SEARCH_ANALYTICS_TITLE: 'Search Analytics',
	SUBTITLE: 'User Data',
}

export const LEADING_PRICE_ROUTES = {
	PATH: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_PATH,
	TITLE: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_TITLE,
	SUBTITLE: BUSINESS_LOGISTICS_ROUTES.LEADING_ANALYZER_SUBTITLE,
}